
import './App.css';
import Footer from './components/Footer';
import Header from './components/Header';
import About from './pages/About';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import Home from './pages/Home';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SmartClassRooms from './pages/smartClassrooms';
import ScienceLab from './pages/scienceLab';
import ComputerLab from './pages/computerLab';
import Yoga from './pages/yoga';
import VanFacility from './pages/vanFacility';
import Sports from './pages/sports';
import PrePrimarySchool from './pages/prePrimary';
import PrimarySchool from './pages/primarySchool';
import HighSchool from './pages/highSchool';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <div className=''>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/smart-classroom" element={<SmartClassRooms />} />
          <Route path="/science-lab" element={<ScienceLab />} />
          <Route path="/computer-lab" element={<ComputerLab />} />
          <Route path="/yoga" element={<Yoga />} />
          <Route path="/van-facility" element={<VanFacility />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/pre-primary" element={<PrePrimarySchool />} />
          <Route path="/primary" element={<PrimarySchool />} />
          <Route path="/high-school" element={<HighSchool />} />
        </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
